import * as Yup from "yup";
import { effluentCodes } from "../../../../utils/dataAndFormulas/effluentForms";

//const currentYear = new Date().getFullYear();

export function initialValues(effluent, period, year, unitsRecorded) {
  return {
    date: effluent?.date || "",
    period: effluent?.period || period,
    year: effluent?.year || year,
    creator_user: effluent?.creator_user || "",
    state: effluent?.state || "",
    domestic_effluents: effluent?.domestic_effluents || {
      code: effluentCodes["domestic_effluents"],
      value: 0,
        unit: unitsRecorded?.["domestic_effluents"] || "",
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    industrial_effluents: effluent?.industrial_effluents || {
      code: effluentCodes["industrial_effluents"],
      value: 0,
        unit: unitsRecorded?.["industrial_effluents"] || "",
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    combined_effluents: effluent?.combined_effluents || {
      code: effluentCodes["combined_effluents"],
      value: 0,
        unit: unitsRecorded?.["combined_effluents"] || "",
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    sludge_and_mud: effluent?.sludge_and_mud || {
      code: effluentCodes["sludge_and_mud"],
      value: 0,
        unit: unitsRecorded?.["sludge_and_mud"] || "",
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    treatment_cost_domestic_effluents:
      effluent?.treatment_cost_domestic_effluents || {
        code: effluentCodes["treatment_cost_domestic_effluents"],
        value: 0,
          unit: unitsRecorded?.["treatment_cost_domestic_effluents"] || "",
        reviews: [],
        approvalStatus: "pending",
        files: [],
      },
    industrial_effluent_treatment_cost:
      effluent?.industrial_effluent_treatment_cost || {
        code: effluentCodes["industrial_effluent_treatment_cost"],
        value: 0,
          unit: unitsRecorded?.["industrial_effluent_treatment_cost"] || "",
        reviews: [],
        approvalStatus: "pending",
        files: [],
      },
    combined_treatment_cost: effluent?.combined_treatment_cost || {
      code: effluentCodes["combined_treatment_cost"],
      value: 0,
        unit: unitsRecorded?.["combined_treatment_cost"] || "",
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    sludge_treatment_cost: effluent?.sludge_treatment_cost || {
      code: effluentCodes["sludge_treatment_cost"],
      value: 0,
        unit: unitsRecorded?.["sludge_treatment_cost"] || "",
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    recycled_effluents: effluent?.recycled_effluents || {
      code: effluentCodes["recycled_effluents"],
      value: 0,
        unit: unitsRecorded?.["recycled_effluents"] || "",
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
  };
}

export function validationSchema() {
  return Yup.object({
    period: Yup.string("Dato requerido").required(
      "El campo periodo es obligatorio"
    ),

    // Ejemplo para un campo
     domestic_effluents: Yup.object({
    value: Yup.number()
      .min(0, "Debe ser mayor o igual a 0")
      .required("Debe ingresar un valor"),
    unit: Yup.string().when("value", {
      is: (val) => val !== 0 && val !== null && val !== "",
      then: (schema) => schema.required("Debe completar la unidad"),
      otherwise: (schema) => schema.notRequired(),
    }),
  }),
  industrial_effluents: Yup.object({
    value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
    unit: Yup.string().when("value", {
      is: (val) => val !== 0 && val !== null && val !== "",
      then: (schema) => schema.required("Debe completar la unidad"),
      otherwise: (schema) => schema.notRequired(),
    }),
  }),
  combined_effluents: Yup.object({
    value: Yup.number()
       .transform((val) => (val === "" || val == null ? 0 : val))
      .min(0, "Debe ser mayor o igual a 0"), // sin .required()
    unit: Yup.string().when("value", {
      is: (val) => val !== 0 && val != null && val !== "",
      then: (schema) => schema.required("Debe completar la unidad"),
      otherwise: (schema) => schema.notRequired(),
    }),
  }).test(
    "combined-check",
    "No se debe completar si ya ingreso información en el campo Efluente doméstica o de Producción",
    function (combined) {
      const { domestic_effluents, industrial_effluents } = this.parent;
      const domesticValue = domestic_effluents?.value || 0;
      const industrialValue = industrial_effluents?.value || 0;
      const combinedValue = combined?.value || 0;

      // Si hay valor en alguno de los otros dos y combined tiene valor -> error
      if ((domesticValue > 0 || industrialValue > 0) && combinedValue > 0) {
        return this.createError({ path: "combined_effluents.value" }); // pone el error en value
      }

      return true;
    }
  ),
    sludge_and_mud: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    treatment_cost_domestic_effluents: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    industrial_effluent_treatment_cost: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    combined_treatment_cost: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
        sludge_treatment_cost: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
          recycled_effluents: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),

  });
}
